import {COLORS, FONT_SIZES, FONT_WEIGHTS} from '@aboutyou/ui-components';
import styled, {css} from 'styled-components';
import {DownloadButton} from './AppOnlyInfoFlyout';

export const DownloadAppButton = styled(DownloadButton)<{
  $isDisabled?: boolean;
}>`
  &&&& {
    width: auto;
    font-size: ${FONT_SIZES.px12};
    font-weight: ${FONT_WEIGHTS.mediumBold};
    line-height: ${FONT_SIZES.px18};
    padding: 7px 8px;
  }

  svg {
    height: 14px;
    width: 14px;
    flex-basis: 14px;
  }

  ${({$isDisabled}) =>
    $isDisabled &&
    css`
      &&& {
        --background-color: ${COLORS.Grey1};
        --color: ${COLORS.White};
      }
    `}
`;
